import React from 'react';
import { useState, useEffect } from 'react';
import Link from '../../components/Link';

import Breadcrumbs from "../components/Breadcrumbs";
import Paginator from "../components/Paginator";

import { styled } from "../../stitches.config";
import { h2, p } from '../commonStyles/Fonts';

import Loader from '../../components/Loader';
import axios from 'axios';
import Footer from "../components/Footer"

type fetchData = {
    categoryId: string,
    categoryName: string,
    dateString: string,
    articles: {
        id: string,
        title: string,
        url: string,
        slug: string,
        hour: string,
    }[],
    currentPage: number,
    pages: number,
}

const PostsMapSubpage = () => {

    // format URLa:
    // baza/:id(categoryId,date,page)

    // baza url do endpointa
    // const urlBase = `${window.location.hostname}`
    // console.log("host:" + window.location.hostname)
    // sprawdzenie formatu urla (czy ma 2 przecinki w id)
    const urlRegex = /^(?:\w+,){2,}(?:\w+)$/;
    // pobranie id urla
    const url = window.location.pathname.substring(window.location.pathname.lastIndexOf("/") + 1);
    // pobranie id urla bez numeru strony (page)
    const urlLocation = url.match(urlRegex) ? url.substring(0, url.lastIndexOf(",")) : url;
    // pobieranie poszczególnych części z id urla
    const categoryId = url.split(",")[0]
    const date = url.split(",")[1]
    // dane o artykułach
    const [data, setData] = useState<fetchData>();
    // state loadera
    const [isLoading, setIsLoading] = useState<boolean>(true);
    // state aktualnej strony
    const [currentPage, setCurrentPage] = useState<number>(url.match(urlRegex) ? Number(url.substr(url.lastIndexOf(',') + 1)) : 1);

    // sekcja propsów do paginatora
    const onPageChange = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    }

    const onPrevClick = () => {
        setCurrentPage(prev => prev - 1);
    }

    const onNextClick = () => {
        setCurrentPage(prev => prev + 1);
    }

    const paginationAttributes = {
        currentPage,
        urlLocation,
        response: data,
    };

    useEffect(() => {
        // formatowanie zapytania do API

        const dataFetch = () => {
            axios.get(`https://${window.location.hostname}/api/posts-map/?categoryId=${categoryId}&date=${date}&page=${currentPage}`).then(response => setData(response.data)).then(() => setIsLoading(false)).catch(err => { console.error(err) });
        }
        dataFetch()
    }, [currentPage]);

    console.log(`https://${window.location.hostname}/api/posts-map/?categoryId=${categoryId}&date=${date}&page=${currentPage}`)

    // warunek na loadera
    if (isLoading) {
        return (
            <Loader />
        )
    }
    return (
        <>
            <WrapBizon>
                < div className="container" >
                    <Breadcrumbs
                        category={{ name: "Mapa artykułów", link: "/posts-map" }}
                        subCategory={{ name: `${data?.categoryName}: ${data?.dateString}` || "", link: "" }}
                        invert
                    />
                    <FlexWrapper>
                        <RightColumn>
                            <h2 className={h2()}>{data?.categoryName}: {data?.dateString}</h2>
                            <ul>
                                {
                                    data && data.articles.map((item, index) => {
                                        return <li key={index}><Link to={item.url}>{item.hour} - {item.title}</Link></li>
                                    })
                                }
                            </ul>
                        </RightColumn>

                    </FlexWrapper>
                    {
                        data && <Paginator {...paginationAttributes} pages={data ? data.pages : 1} onPrevClick={onPrevClick} onNextClick={onNextClick} onPageChange={onPageChange}></Paginator>
                    }

                </div >
            </WrapBizon>
            <Footer />
        </>
    )
}

export default PostsMapSubpage;


const WrapBizon = styled("div", {
    background: "$grayscale10",
    padding: "64px 0 0 0",
    position: "relative",
    "@bp4": {
        padding: "40px 0 0 0",
    },
    "& .breadcrumbs": {
        "& ul": {
            "& li:nth-child(2)": {
                textTransform: "capitalize",
            },
        },
    },
    '.container': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    }
});

const FlexWrapper = styled("div", {
    marginTop: "24px",
    "@bp4": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        maxWidth: "1164px",
    },
});

const RightColumn = styled("div", {
    marginTop: "30px",
    color: "$grayscale100",
    width: "100%",
    "@bp4": {
        maxWidth: "100%",
    },
    "& ol": {
        paddingLeft: "16px",
        "@bp4": {
            paddingLeft: "24px",
        },

        "& li": {
            marginBottom: "15px",
        }
    },

    "& a": {
        color: "$primary",
        fontSize: '16px',
        "&:hover": {
            color: "$primary",
        }
    },
    "& .centered": {
        textAlign: "left",
        position: "relative",
        padding: "32px 0 16px 0",
        "@bp4": {
            padding: "56px 0 16px 0",
        },
        "&:before": {
            content: "",
            position: "absolute",
            top: 0,
            left: 0,
            width: "54px",
            height: "7px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            "@bp4": {
                width: "76px",
                height: "10px",
            }
        }
    },
});